import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Zap, Users, Trophy, Target } from 'lucide-react';
const problems = [{
  icon: Zap,
  title: 'Fragmented Chaos',
  description: 'Extreme sports content is scattered across a dozen platforms. We bring the noise to one deafening hub.'
}, {
  icon: Users,
  title: 'Ghost Towns',
  description: "Generic gaming communities don't get the rush. Connect with adrenaline junkies who live for the drop."
}, {
  icon: Trophy,
  title: 'Empty Victories',
  description: 'Casual lobbies offer no glory. Compete in high-stakes tournaments built for the elite.'
}, {
  icon: Target,
  title: 'Amateur Hour',
  description: 'Stop guessing. Get pro-level training content from the legends of the track and slope.'
}];
export function Problems() {
  return <section className="bg-neutral-950 py-24 relative overflow-hidden" data-id="element-144">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"
    }} data-id="element-145" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-146">
        <div className="mb-16 text-center" data-id="element-147">
          <h2 className="text-4xl md:text-6xl font-black text-white uppercase italic tracking-tighter mb-4" data-id="element-148">
            The <span className="text-red-600" data-id="element-149">Problem</span>
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto skew-x-[-20deg]" data-id="element-150" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-151">
          {problems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-neutral-900/50 border border-neutral-800 p-8 hover:bg-red-950/20 hover:border-red-900/50 transition-all duration-300 skew-x-[-3deg]" data-id="element-152">
              <div className="skew-x-[3deg]" data-id="element-153">
                <div className="w-12 h-12 bg-red-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-154">
                  <item.icon className="text-white w-6 h-6" data-id="element-155" />
                </div>
                <h3 className="text-xl font-bold text-white uppercase mb-3 tracking-tight" data-id="element-156">
                  {item.title}
                </h3>
                <p className="text-neutral-400 leading-relaxed text-sm" data-id="element-157">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}